import { Observable } from "rxjs";
import { inject, Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { CoolOffWidgetModel } from "@modules/uk-finprom/components/cool-off-widget/entities/cool-off-widget.model";
import { map } from "rxjs/operators";

@Injectable({
	providedIn: "root"
})
export class CoolOffWidgetRemote {
	private readonly apiCallService = inject(ApicallService);

	public getPreTradeData$(): Observable<CoolOffWidgetModel> {
		return this.apiCallService
			.get("questionnaires-onboarding/pre-trade-status")
			.pipe(map((data) => data.attributes));
	}

	public postLastCheck$(): Observable<void> {
		const options = new ApicallOption(null);
		options.hasNullResponse = true;

		return this.apiCallService.post("questionnaires-onboarding/accept-last-check", options);
	}

	public startUserCoolOff$(): Observable<void> {
		return this.apiCallService.post("questionnaires-onboarding/start-user-cool-off", new ApicallOption(null));
	}
}
